import { connect } from 'react-redux';
import { withRouter } from 'utils/withRouter';
import UploadingFileComponents from '../components';

export default withRouter(connect()(UploadingFileComponents));
